import React from 'react';
import { LANGUAGE_CODE_MAP } from 'Store/locales/constants';

import styles from './GamePlayerControls.scss';
import LabelIcon from './label.svg';
import SoundIcon from './sound.svg';
import FullScreenIcon from './fullscreen.svg';

function GamePlayerControls({
  fullscreenSupported,
  gameLoaded,
  gameSettings,
  onAudioToggle,
  onLabelToggle,
  onLanguageSelect,
  onFullScreenToggle,
}) {
  if (!gameSettings) return null;
  const {
    labels,
    languageCodes,
    currentLanguage,
    audio,
    fullscreen,
  } = gameSettings;
  return (
    <div
      className={`GamePlayerControls ${
        gameLoaded ? 'is-loaded' : 'is-loading'
      }`}
    >
      <div className="GamePlayerControls__group-sound">
        <SoundIcon
          className={`GamePlayerControls__sound is-${audio}`}
          onClick={onAudioToggle}
        />
      </div>
      <div className="GamePlayerControls__group-text">
        <LabelIcon
          onClick={onLabelToggle}
          className={`GamePlayerControls__labels is-${labels}`}
        />
        <select
          className="GamePlayerControls__language"
          onChange={onLanguageSelect}
          defaultValue={gameSettings.currentLanguage}
        >
          {gameSettings.languageCodes.map(lang => {
            const label = LANGUAGE_CODE_MAP[lang]
              ? LANGUAGE_CODE_MAP[lang]
              : lang;
            return (
              <option value={lang} key={lang}>
                {label}
              </option>
            );
          })}
        </select>
      </div>
      <div className="GamePlayerControls__group-screen">
        {fullscreenSupported ? (
          <FullScreenIcon
            className={`GamePlayerControls__fullscreen  is-${fullscreen}`}
            onClick={onFullScreenToggle}
          />
        ) : null}
      </div>
    </div>
  );
}

export default GamePlayerControls;
